var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 10.6666,
    width: 137.333,
    height: 138.667,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.32 12C25.08 12 12 25.864 12 47.328V112.672C12 134.136 25.08 148 45.32 148H114.664C134.912 148 148 134.136 148 112.672V47.328C148 25.864 134.912 12 114.672 12H45.32ZM114.664 160H45.32C18.208 160 0 140.976 0 112.672V47.328C0 19.024 18.208 0 45.32 0H114.672C141.784 0 160 19.024 160 47.328V112.672C160 140.976 141.784 160 114.664 160Z",
    fill: "#1AB759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5107 104.984C68.9827 104.984 67.4387 104.4 66.2708 103.224L47.2788 84.2402C44.9348 81.8962 44.9348 78.1042 47.2788 75.7602C49.6228 73.4162 53.4148 73.4162 55.7588 75.7602L70.5107 90.4962L104.239 56.7762C106.583 54.4322 110.375 54.4322 112.719 56.7762C115.063 59.1202 115.063 62.9122 112.719 65.2562L74.7507 103.224C73.5827 104.4 72.0467 104.984 70.5107 104.984Z",
    fill: "#1AB759"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.2a4459f4aba248a9d27cb899cc0a0191.svg";
export { ForwardRef as ReactComponent };